import type { SupplyCrateCardView, SupplyCrateResultView } from "../../game/crates/view";
export { formatDuration } from "../format";

export function crateRewardChips(crate: SupplyCrateCardView): readonly HTMLElement[] {
  const [cashRange, coreRange] = crate.rewardLine.split(" | ");
  return [
    effectChip("CASH", cashRange.replace(" CR", "")),
    effectChip("SPAWNS", coreRange)
  ];
}

export function resultTitle(resultView: SupplyCrateResultView): string {
  if (resultView.result.jackpot) {
    return "JACKPOT HIT";
  }
  if (resultView.result.lucky) {
    return "LUCKY DROP";
  }
  return resultView.result.crateId === "free" ? "SUPPLY DROP" : resultView.crateName;
}

export function textSpan(text: string, className: string): HTMLElement {
  const span = document.createElement("span");
  span.className = className;
  span.textContent = text;
  return span;
}

export function effectChip(label: string, value: string): HTMLElement {
  const chip = document.createElement("span");
  chip.className = "of-crate-effect-chip";

  const tag = document.createElement("span");
  tag.className = "of-crate-effect-tag";
  tag.textContent = label;

  const text = document.createElement("span");
  text.className = "of-crate-effect-value";
  text.textContent = value;

  chip.append(tag, text);
  return chip;
}
